/**
 *  ######################################
 *  ### DO NOT EDIT THIS FILE DIRECTLY ###
 *  ######################################
 *
 * This file is generated from:
 * /crates/mgo-open-rpc/spec/openrpc.json
 */

import type { GetDynamicFieldObjectParams } from '@mgonetwork/mango.js/client';

import type { UseMgoClientQueryOptions } from '../useMgoClientQuery.js';
import { useMgoClientQuery } from '../useMgoClientQuery.js';

export function useDynamicFieldObject(
	params: GetDynamicFieldObjectParams,
	options?: UseMgoClientQueryOptions<'getDynamicFieldObject'>,
) {
	return useMgoClientQuery(
		{
			method: 'getDynamicFieldObject',
			params,
		},
		options,
	);
}
